<template>
	<div>
		<Tab name="4"></Tab>
		<el-tabs type="border-card" v-model="tabValue">
			<el-tab-pane name="1">
				<span slot="label"><i class="el-icon-s-data"></i> 数据列表</span>
				<template v-if="tabValue == '1'">
					<data-list></data-list>					
				</template>
			</el-tab-pane>
			<el-tab-pane name="2">
				<span slot="label"><i class="el-icon-edit"></i> track管理</span>
				<template v-if="tabValue == '2'">
					<track-list></track-list>
				</template>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	import Tab from "../components/tab";
	import dataList from './components/dataList.vue';
	import trackList from './components/trackList.vue';
	export default {
		components: {
			Tab,
			dataList,
			trackList,
		},
		data() {
			return {
				tabValue: "1",
			}
		},
		mounted() {
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>

</style>